<div class="row">
	<div class="card col-md-12">
		<div class="card-body" *ngIf="questionSet?.display_type === 'MultipleChoiceGrid'">
			
			<!-- question_class_size: {{question_class_size}}
			singleQuestion: {{isSingleQuestion}}
			question set {{questionSet?.questions.length}} -->
			<div class="row no-gutter questions-header d-none" [ngClass]="{'d-lg-flex': !isSingleQuestion}">
				<div class="col-lg-{{question_class_size}}"></div>
				<div class="secondary-color white-text set-label pt-3 pb-3 col-md-1" *ngFor="let label of questionSet.labels; let last = last;"
				 (click)="selectLabel(questionSet,label)">
					<h6 class="h6-responsive">{{label.label}}</h6>
				</div>
				<div class="filler secondary-color white-text set-label pt-3 pb-3" [ngClass]="getLabelClasses()"></div>
			</div>

			<div class="row question-item mb-3 mb-lg-0" *ngFor="let question of questionSet.questions">
				<dac-question class="col" 
					[vertical]="isSingleQuestion" [question]="question" [labels]="questionSet.labels"></dac-question>
			</div>
		</div>
		<!-- TODO: stephen do I even need this type anymore?-->
		<div class="card-body" *ngIf="questionSet?.display_type === 'SingleSelectDropdown'">
			<div class="row question-item mb-3 mb-lg-0" *ngFor="let question of questionSet.questions">
				<app-question-dropdown  class="col" vertical="isSingleQuestion" [question]="question"
				[labels]="questionSet.labels">
				</app-question-dropdown>
			</div>
		</div>
		<dac-question-list-item class="card-body" *ngIf="questionSet?.display_type === 'QuestionList'"
		 [QuestionSet]="questionSet"></dac-question-list-item>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/assessments/question-set/question-set.component.html